import { createBrowserClient } from "@supabase/ssr";
import { SupabaseKey, SupabaseUrl } from "../env";

export function createClient() {
	return createBrowserClient(SupabaseUrl, SupabaseKey);
}

// import { createClient as createSupabaseClient } from "@supabase/supabase-js";
//
// export const supabaseClient = createSupabaseClient(supabaseUrl, supabaseKey);
// export function createClient() {
// 	return supabaseClient;
// }
